import {
  ErrorResponseCodeType,
  EndPointsNames,
  ApiCredentialsType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/members/password';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType =
  'TOKEN_AUTH_USER_OR_CREDENTIALS';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/Conta~1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/7987dbc3-04cb-4aa3-a808-85fdbd6748ce?version=5751ac05-6b93-4aad-aec5-d61bc5dfb2b8&tab=overview';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
  {
    code: '7',
    bussinessErrorVariant: 'errorChangePassword',
    message: 'Ocorreu um erro ao alterar senha',
  },
  {
    code: '8',
    bussinessErrorVariant: 'tokenExpired',
    message: 'Falha ao verificar token',
  },
  {
    code: '45',
    bussinessErrorVariant: 'invalidPassword',
    message: 'Senha não pode ter dígitos sequenciais ou 4 dígitos repetidos',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
